import { render, staticRenderFns } from "./ClientCreateDialog.vue?vue&type=template&id=6c167cf6&scoped=true"
import script from "./ClientCreateDialog.vue?vue&type=script&lang=js"
export * from "./ClientCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./ClientCreateDialog.vue?vue&type=style&index=0&id=6c167cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c167cf6",
  null
  
)

export default component.exports